module.exports = __webpack_public_path__ + "static/media/Wechat.46c20dd0.jpg";